import { Permission } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';

export class RolePermission {
  @autoserialize
  roleId: number;

  @autoserializeAs(Permission)
  permission: Permission;
}
